import { GraphQlMutationResult, MutationSuccessResultCreator } from '../../graphql-result';

/**
 * This class is responsible for creating a mutation result for a successful dismissal response.
 */
export class DismissalSuccessResultCreator extends MutationSuccessResultCreator {
  constructor(response, dismissalData) {
    super(response, dismissalData);
    this.response = response;
    this.dismissalData = dismissalData;
  }
  makeMutationResult() {
    return new GraphQlMutationResult(this.response.status, this.response.statusText, {
      data: this.dismissalData
    });
  }
}
export class UndoDismissalSuccessResultCreator extends MutationSuccessResultCreator {
  constructor(response, undoDismissalData) {
    super(response, undoDismissalData);
    this.response = response;
    this.undoDismissalData = undoDismissalData;
  }
  makeMutationResult() {
    return new GraphQlMutationResult(this.response.status, this.response.statusText, {
      data: this.undoDismissalData
    });
  }
}